/* TECH 2026-10-23 · JS de la landing "10% extra BF" (sections/nook-extra10.liquid). Se carga con defer; no depende de jQuery.
   QUÉ: (1) contador a la fecha/hora de la sección; (2) formulario propio → Klaviyo Client API + klaviyo.identify.
   POR QUÉ: formulario con el diseño aprobado (fuentes del tema, editable en el personalizador) y que el "Added to Cart"
            quede ligado al mail para armar el segmento del 8 de noviembre.
   REVERTIR: borrar este archivo junto con la sección y la plantilla. */
(function () {
  'use strict';
  var REVISION = '2026-10-15'; // revisión de la Client API de Klaviyo vigente al 23-oct-2026
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown(root) {
    var el = root.querySelector('[data-nx10-count]');
    if (!el) return;
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) return; // fecha mal escrita en el editor: se queda en 00
    var cells = el.querySelector('[data-nx10-cells]');
    var done = el.querySelector('[data-nx10-done]');
    var u = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = el.querySelector('[data-u="' + k + '"]'); });
    var timer;
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var t = Math.floor(diff / 1000);
      u.d.textContent = pad(Math.floor(t / 86400));
      u.h.textContent = pad(Math.floor((t % 86400) / 3600));
      u.m.textContent = pad(Math.floor((t % 3600) / 60));
      u.s.textContent = pad(t % 60);
      if (diff <= 0) {
        clearInterval(timer);
        if (done && done.textContent.trim()) { cells.hidden = true; done.hidden = false; }
      }
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  function identify(email) {
    // klaviyo.js (app embed de Klaviyo) expone window.klaviyo. Si aún no carga, se encola en _klOnsite y klaviyo.js lo procesa al cargar.
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else {
        (window._klOnsite = window._klOnsite || []).push(['identify', { email: email }]);
      }
    } catch (e) { /* nunca romper el envío por esto */ }
  }

  function initForm(root) {
    var form = root.querySelector('[data-nx10-form]');
    if (!form) return;
    var msg = form.querySelector('[data-nx10-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var input = form.querySelector('input[name="email"]');
    function show(type, text) {
      msg.className = 'nx10-msg ' + (type === 'ok' ? 'is-ok' : 'is-err');
      msg.textContent = text;
    }
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (form.querySelector('[name="nx10_hp"]').value) return; // bot
      var email = (input.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(email)) { show('err', form.dataset.msgInvalid); input.focus(); return; }
      var company = form.dataset.company, list = form.dataset.list;
      if (!company || !list) {
        console.warn('[nx10] Falta company_id o list_id de Klaviyo en la sección; no se envió nada.');
        show('err', form.dataset.msgErr);
        return;
      }
      btn.disabled = true;
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.source || 'Landing 10% extra BF',
            profile: { data: { type: 'profile', attributes: {
              email: email,
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (r.status !== 202 && !r.ok) throw new Error('HTTP ' + r.status);
        identify(email); // mismo envío: liga el navegador al mail (Added to Cart → perfil)
        show('ok', form.dataset.msgOk);
        form.reset();
        var okb = form.querySelector('[data-nx10-okbtn]');
        if (okb) okb.hidden = false;
        form.classList.add('is-done'); // oculta campo y botón; queda el mensaje + "Seguir comprando"
        try { if (form.dataset.lead === '1' && window.fbq) window.fbq('track', 'Lead', { content_name: 'Landing 10% extra BF' }); } catch (e) {}
      }).catch(function (e) {
        console.warn('[nx10] Klaviyo no aceptó la suscripción', e);
        show('err', form.dataset.msgErr);
      }).then(function () { btn.disabled = false; });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-nx10]').forEach(function (root) {
      if (root.__nx10) return; root.__nx10 = true;
      initCountdown(root); initForm(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Editor de temas: re-inicializa al editar la sección
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
